<!--
 * @Description: 
 * @version: 
 * @Author: m
 * @LastEditors: m
-->
<template>
	<div>
		<van-form>
			<van-field v-model="form.process_name" label="流程" readonly />
			<van-field v-model="form.xmmc" label="项目名称" readonly />
			<van-field v-model="form.hxsj" label="花销时间" readonly />
			<van-field v-model="bxlxList[form.bxlx]" name="报销类型" label="报销类型" readonly />
			<van-field v-model="form.bxsm" label="报销说明" readonly />
			<van-field v-model="form.je" label="金额" readonly />
		</van-form>
	</div>
</template>

<script>
export default {
	name: "purchase",
	props: {
		rform: Object
	},
	data() {
		return {
			form: {
				xmmc: "",
				hxsj: "",
				bxsm: "",
				bxlx: "",
				je: ""
			},
			bxlxList: ["交通", "住宿", "餐饮", "其他"]
		};
	},
	watch: {
		rform: {
			immediate: true,
			handler(newV) {
				this.form = newV;
			}
		}
	}
};
</script>